
<div class="w-full flex flex-row justify-center bg-themeComponentBg-light service-area-card-gallery-outer-container">
  <section class="w-full mx-5 max-w-1216">
    <div class="container">
      <div class="header">
        <p class="tagline">{{ tagline }}</p>
        <h1 class="main-heading">{{ heading }}</h1>
        <p class="description">{{ description }}</p>
      </div>
      <div class="feature-container">
        <FeatureCard
          v-for="(feature, index) in features"
          :key="index"
          :is-active="activeIndex === index"
          @mouseenter.native="handleMouseEnter(index)"
          @mouseleave.native="handleMouseLeave"
          :feature="feature"
          :label-background-color="brandColor"
          :label-text-color="'#FFFFFF'"
          :feature-content-background-color="brandColor"
          :feature-content-text-color="'#FFFFFF'"
          :page="page"
        />
      </div>
    </div>
  </section>
</div>
